export function initSearch() {
    const forms = document.querySelectorAll('[data-head-search-form]');
    forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
            var _a;
            event.preventDefault();
            let searchValue = null;
            const mobileInput = document.querySelector('[data-mobile-input]');
            const desktopInput = document.querySelector('[data-desktop-input]');
            // Check if mobile input has a value
            if (mobileInput === null || mobileInput === void 0 ? void 0 : mobileInput.value) {
                searchValue = mobileInput.value;
                desktopInput.disabled = true;
            }
            else if (desktopInput === null || desktopInput === void 0 ? void 0 : desktopInput.value) {
                searchValue = desktopInput.value;
                mobileInput.disabled = true;
            }
            const submittedForm = event.target;
            (_a = window.amplitude) === null || _a === void 0 ? void 0 : _a.track('Search Items', {
                query: searchValue
            });
            submittedForm.submit();
        });
    });
}
